import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../store/store"; // Assuming your store file is named 'store.ts'
import { Space, Spin, Table } from "antd";
import {
  AimOutlined,
  BellOutlined,
  CloseOutlined,
  DollarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { MetricCard } from "../components/MetricCard";
import { fetchData } from "../store/actions/cms";
import { PATH_API_MANAGE } from "../config";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { queryApi } from "../store/actions/common";
import { queryClient } from "../store/queryClient";
import { triggerNotification } from "../store/directActions";
import CustomDrawer from "../components/hoc/CustomDrawer";
import socketService from "../config/ws-config";
import { capitalize } from "lodash";
import moment from "moment";

interface OwnProps {
  // Define any props specific to CorePage here
}

type CorePageProps = OwnProps & PropsFromRedux;

const CorePage: React.FC<CorePageProps> = ({ loading, fetchData, data }) => {
  const [showDrawer, setShowDrawer] = useState<string | null>(null);

  useEffect(() => {
    fetchData({});
  }, []);

  const { data: paymentData } = useQuery({
    queryKey: ["store/payments"],
    queryFn: () => queryApi("store/payments", "GET"),
    staleTime: Infinity,
    gcTime: 0,
  });

  const { mutate: removeSubscription } = useMutation({
    mutationFn: (payload: any) =>
      queryApi("store/subscription", "DELETE", payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["store/payments"] });
    },
    onError: (a) => {
      triggerNotification({
        title: "Error",
        description: a.message,
        type: "error",
      });
    },
  });

  const paymentColumns = [
    {
      title: "Store",
      dataIndex: "store",
      key: "store",
      render: (item: any) => item?.name ?? "",
    },
    {
      title: "Bill date",
      dataIndex: "created_at",
      key: "created_at",
      render: (item: any) => <div>{moment(item).format("MMMM DD, YYYY")}</div>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (item: any) => <div>${item}</div>,
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "subscription",
      render: (item: any, record: any) => (
        <Space size="middle">
          {record.payment_status === "pending" && !!record.store && !!item && (
            <>
              <CloseOutlined
                style={{ fontSize: 22, color: "red" }}
                onClick={() => {
                  removeSubscription({
                    subscription_id: item?.subscription_id,
                    store_id: item?.store_id,
                  });
                  socketService.sendMessage(
                    "get-payment-status",
                    {},
                    record.store?.owner_id
                  );
                }}
              />
              <BellOutlined
                style={{ fontSize: 22, color: "blue" }}
                onClick={() => {
                  socketService.sendMessage(
                    "get-payment-status",
                    {},
                    record.store?.owner_id
                  );
                  triggerNotification({
                    title: "Payment notification sent to store",
                    type: "success",
                    description: "",
                  });
                }}
              />
            </>
          )}
        </Space>
      ),
    },
  ];

  const filteredPayments = Array.isArray(paymentData)
    ? paymentData.filter((item: any) => {
        if (showDrawer?.includes("pending"))
          return item.payment_status === "pending";
        else if (showDrawer?.includes("paid"))
          return item.payment_status === "success";
        else return false;
      })
    : [];

  if (loading)
    return (
      <div className="w-full h-full flex justify-center items-center">
        <Spin />
      </div>
    );

  return (
    <section id="dashboard" className="page-section min-h-screen p-6">
      <div className="space-y-6">
        {/* Key Metrics */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <MetricCard
            title="Total Users"
            value={`${data?.total_users || 0}`}
            icon={<AimOutlined style={{ fontSize: 20 }} />}
            trend="up"
          />
          <MetricCard
            title="Invoice Paid"
            value={`${data?.invoice_paid || 0}`}
            icon={<DollarOutlined style={{ fontSize: 20 }} />}
            trend="up"
            clickable
            onClick={() => setShowDrawer("invoice_paid")}
          />
          <MetricCard
            title="Invoice Pending"
            value={`${data?.invoice_pending || 0}`}
            icon={<UserOutlined style={{ fontSize: 20 }} />}
            trend="up"
            clickable
            onClick={() => setShowDrawer("invoice_pending")}
          />
        </div>

        {/* Charts and Quick Actions */}
        {/* <Row gutter={[24, 24]}>
          <Col xs={24} lg={16}>
            <Card
              title="Daily Sales"
              className="app-surface backdrop-blur-xl shadow-xl app-border"
            >
            </Card>
          </Col>

          <Col xs={24} lg={8}>
            <Card
              title="Quick Actions"
              className="app-surface backdrop-blur-xl shadow-xl app-border mb-6"
            >
              <div className="space-y-3">
                <Button
                  type="default"
                  icon={<PlusOutlined />}
                  block
                  size="large"
                  className="text-left flex items-center justify-start"
                >
                  <div className="ml-2">
                    <div className="font-medium">Add Store</div>
                    <div className="text-xs app-muted">
                      Register a new store
                    </div>
                  </div>
                </Button>
                <Button
                  type="default"
                  icon={<ContainerOutlined />}
                  block
                  size="large"
                  className="text-left flex items-center justify-start"
                >
                  <div className="ml-2">
                    <div className="font-medium">Manage Inventory</div>
                    <div className="text-xs app-muted">
                      Update ticket inventory
                    </div>
                  </div>
                </Button>
                <Button
                  type="default"
                  icon={<EyeOutlined />}
                  block
                  size="large"
                  onClick={() => setShowDrawer("invoice_pending")}
                  className="text-left flex items-center justify-start"
                >
                  <div className="ml-2">
                    <div className="font-medium">View Payments</div>
                    <div className="text-xs app-muted">
                      Check payment status
                    </div>
                  </div>
                </Button>
              </div>
            </Card>
          </Col>
        </Row> */}

        {/* Recent Activity */}
        {/* <Card
          title="Recent Activity"
          className="app-surface backdrop-blur-xl shadow-xl app-border"
        >
          <List
            itemLayout="horizontal"
            dataSource={[]}
            renderItem={(activity, index) => (
              <List.Item>
                <List.Item.Meta
                  avatar={<Avatar size="small" />}
                  title={activity.action}
                  description={activity.store}
                />
                <div className="text-xs app-muted">{activity.time}</div>
              </List.Item>
            )}
          />
        </Card> */}
      </div>

      <CustomDrawer
        title={capitalize(showDrawer?.replaceAll("_", " ") ?? "")}
        width="50%"
        onClose={() => setShowDrawer(null)}
        open={!!showDrawer}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Table
          columns={paymentColumns}
          dataSource={filteredPayments}
          size="small"
          sticky
          tableLayout="auto"
          pagination={false}
        />
      </CustomDrawer>
    </section>
  );
};

const mapStateToProps = (state: RootState) => ({
  data: state?.cms?.dashboard ?? {},
  loading: state.notification.isLoading,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchData: (reqData: any) =>
    dispatch(
      fetchData(PATH_API_MANAGE, `dashboard/admin`, reqData, "dashboard")
    ),
});
const connector = connect(mapStateToProps, mapDispatchToProps);

// Define the props that connect will inject into the component
type PropsFromRedux = ConnectedProps<typeof connector>;

// Connect the component to Redux
export default connector(CorePage);
